import { useSelector } from "react-redux";
import Header from "../layout/Header";
import { NextArr } from "../svg/AllSvg";

const Banner = ({ title, root1, root2 }: any) => {
    const theme: any = useSelector((state: any) => state.ui.theme);

    return (
        <div className="w-full h-[240px] xlx:h-[285px] relative banner-bg">
            <img src={theme === "dark" ? require("../../../assets/images/pages3.png") : require("../../../assets/images/pages.png")} alt="bg-image" className="w-full h-full object-cover" />
            <div className="absolute top-0 left-0 right-0 bottom-0 items-start justify-between w-full flex flex-col pb-[25px] h-full">
                <div className="w-full h-fit">
                    <Header type="passenger" />
                </div>

                <div className="flex flex-wrap xsm:flex-row flex-col xsm:items-center justify-between w-full container gap-y-[5px] gap-x-[15px] md:!px-[30px] xlx:!px-[50px]">
                    <h2 className="text-primaryText dark:text-white font-bold">{title}</h2>
                    {(!!root1 && !!root2) && <h6 className="flex items-center gap-[10px] font-medium text-blackDull dark:text-textBlackDull">{root1} <NextArr /> {root2}</h6>}
                </div>
            </div>
        </div>
    );
};

export default Banner;